import { pickBy } from 'lodash';

export const cleanObject = (obj: Record<string, any>) => pickBy(obj, (key) => !!key || key === false);
